"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatMarkerArray = flatMarkerArray;
exports.getMarkerById = getMarkerById;
exports.getVisibleStandardMarkers = getVisibleStandardMarkers;
exports.useMarkers = useMarkers;
var _react = require("react");
var _enums = require("../../enums");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function flatMarkerArray() {
  var MARKERS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  /**
   * Returns:       flat array of marker objects
   * Return Value:  [{type, id, marker}, ...markerObj]
   * Note:          supports optional ordering
   */

  var _MARKERS$STANDARD = MARKERS.STANDARD,
    STANDARD = _MARKERS$STANDARD === void 0 ? {} : _MARKERS$STANDARD,
    _MARKERS$USERDEFINED = MARKERS.USERDEFINED,
    USERDEFINED = _MARKERS$USERDEFINED === void 0 ? {} : _MARKERS$USERDEFINED;
  var standardMarkers = Object.entries(STANDARD).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      markerName = _ref2[0],
      data = _ref2[1];
    return {
      id: markerName,
      name: markerName,
      type: _enums.MarkerShapesStandard[markerName],
      standard: true,
      data: data
    };
  });
  var userdefinedMarkers = Object.entries(USERDEFINED).flatMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      markerType = _ref4[0],
      markers = _ref4[1];
    return Object.entries(markers).map(function (_ref5) {
      var _markerData$character;
      var _ref6 = _slicedToArray(_ref5, 2),
        uniqueIDString = _ref6[0],
        markerData = _ref6[1];
      return {
        id: uniqueIDString,
        name: markerData === null || markerData === void 0 ? void 0 : (_markerData$character = markerData.characteristics) === null || _markerData$character === void 0 ? void 0 : _markerData$character.markerName,
        type: markerType,
        standard: false,
        data: markerData
      };
    });
  });
  return [].concat(_toConsumableArray(standardMarkers), _toConsumableArray(userdefinedMarkers));
}
function getMarkerById() {
  var _markers$find;
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var markers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (_markers$find = markers.find(function (marker) {
    return marker.id === id;
  })) !== null && _markers$find !== void 0 ? _markers$find : {};
}
function getVisibleStandardMarkers() {
  var MARKERS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _MARKERS$STANDARD2 = MARKERS.STANDARD,
    STANDARD = _MARKERS$STANDARD2 === void 0 ? {} : _MARKERS$STANDARD2;
  var standardMarkers = Object.entries(STANDARD).reduce(function (acc, _ref7) {
    var _data$characteristics;
    var _ref8 = _slicedToArray(_ref7, 2),
      markerName = _ref8[0],
      data = _ref8[1];
    if (((_data$characteristics = data.characteristics) === null || _data$characteristics === void 0 ? void 0 : _data$characteristics.markerEnabledFlag) === true) {
      acc.push(markerName);
    }
    return acc;
  }, []);
  return standardMarkers;
}
function useMarkers() {
  var MARKERS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useState = (0, _react.useState)(MARKERS),
    _useState2 = _slicedToArray(_useState, 2),
    markers = _useState2[0],
    setMarkers = _useState2[1];
  (0, _react.useEffect)(function () {
    setMarkers(MARKERS);
  }, [MARKERS]);
  var markerArray = (0, _react.useMemo)(function () {
    return flatMarkerArray(markers);
  }, [markers]);
  var getByID = (0, _react.useCallback)(function (id) {
    return getMarkerById(id, markerArray);
  }, [markerArray]);
  function deleteById(id) {
    setMarkers(function (prevMarkers) {
      var updatedMarkers = _objectSpread({}, prevMarkers);
      for (var markerType in updatedMarkers) {
        for (var uniqueIDString in updatedMarkers[markerType]) {
          if (uniqueIDString === id) {
            delete updatedMarkers[markerType][uniqueIDString];
          }
        }
      }
      return updatedMarkers;
    });
  }
  return {
    markers: markers,
    markerArray: markerArray,
    getMarkerById: getByID,
    deleteMarkerById: deleteById
  };
}